import { append } from "ramda";

import { IResolve } from "@/types/communal";
import {
  ICoursewareDatum,
  ISearchDataType,
  IShareData,
  ITutorialType,
} from "@/types/index-page";
import { convertKeysToCamel, convertKeysToSnake } from "@/utils/other";

import { api } from "./api";

export const getNotFinishedCoursewareApi = async (
  params?: {
    referenceId?: string;
    direction?: "up" | "down";
    sharedId?: string;
    searchId?: string;
  },
  size = 5
): Promise<IResolve<ICoursewareDatum[]>> => {
  const res: IResolve<ICoursewareDatum[]> = await api.get("/coursewares", {
    params: convertKeysToSnake({ ...params, size }),
  });

  if (Array.isArray(res.data)) {
    if (res.data.length === 1) {
      res.data = append({ ...res.data[0] }, res.data);
    }
    res.data = res.data.map((item) => {
      item.key = crypto.randomUUID();

      return convertKeysToCamel(item);
    });
  }

  return res;
};
export const getShareLinkApi = async (params: {
  shareableType: string;
  shareableId: string;
}): Promise<{ content: string }> => {
  const { data } = await api.post(
    "/sharing/generate",
    convertKeysToSnake(params)
  );

  return data;
};
export const decodeTokenApi = async (token: string): Promise<IShareData> => {
  const { data } = await api.get(`/sharing/${token}`);

  return convertKeysToCamel(data);
};

export const getTutorialsApi = async (
  params?: {
    referenceId?: string;
    direction?: "up" | "down";
    sharedId?: string;
    searchId?: string;
  },
  size = 5
): Promise<IResolve<ITutorialType[]>> => {
  const res: IResolve<ITutorialType[]> = await api.get("/tutorials", {
    params: convertKeysToSnake({ ...params, size }),
  });

  if (Array.isArray(res.data)) {
    if (res.data.length === 1) {
      res.data = append({ ...res.data[0] }, res.data);
    }
    res.data = res.data.map((item) => {
      item.key = crypto.randomUUID();

      return convertKeysToCamel(item);
    });
  }

  return res;
};
export const getSearchCoursewaresAndTutorialsApi = async (
  keyword: string
): Promise<IResolve<ISearchDataType>> => {
  const res: IResolve<ISearchDataType> = await api.get("/search/keys", {
    params: {
      keyword,
    },
  });

  return convertKeysToCamel(res);
};
